"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

require("./CounterBadge.scss");

var _excluded = ["number", "skin", "size", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** The number on the badge. This is required. */
  number: _propTypes.number.isRequired,

  /** Background and color. */
  skin: (0, _propTypes.oneOf)(['neutral', 'success', 'danger', 'info', 'light', 'dark']),

  /** You can choose a size for the badge. */
  size: (0, _propTypes.oneOf)(['small', 'medium', 'large']),

  /** Add your own custom class names to the component. */
  className: _propTypes.string
};
var defaultProps = {
  skin: 'neutral',
  size: 'small'
};
/** A number component suitable as a counter or for displaying a number. */

var CounterBadge = function CounterBadge(_ref) {
  var number = _ref.number,
      skin = _ref.skin,
      size = _ref.size,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = (0, _classnames.default)('rds-counter-badge', {
    'rds-counter-badge--neutral': skin === 'neutral' || !skin || skin === 'default',
    'rds-counter-badge--light': skin === 'light',
    'rds-counter-badge--dark': skin === 'dark',
    'rds-counter-badge--success': skin === 'success',
    'rds-counter-badge--danger': skin === 'danger',
    'rds-counter-badge--info': skin === 'info',
    'rds-counter-badge--small': size === 'small' || !size,
    'rds-counter-badge--medium': size === 'medium',
    'rds-counter-badge--large': size === 'large',
    'rds-counter-badge--extra-padding': number.toString().length > 1
  }, className);
  {
    skin === 'default' && console.error("Skin 'default' is deprecated. Please use 'neutral' instead.");
  }
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: componentClassNames
  }, rest), /*#__PURE__*/_react.default.createElement("span", {
    className: 'rds-counter-badge__number'
  }, " ", number, " "));
};

CounterBadge.propTypes = propTypes;
CounterBadge.defaultProps = defaultProps;
var _default = CounterBadge;
exports.default = _default;